import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSiteVisitReportByFolderId, getWeatherList } from "../../Api/SiteVisitReport/SiteVisitReportApiServices";
import { mapSiteVisitReports, mapWeathers } from "../Types/SiteVisitReport/SiteVisitReportType";

// Fetch site visit reports
export const fetchSiteVisitReports = createAsyncThunk(
    'fetchSiteVisitReports', async (folder_id: number, { rejectWithValue }) => {
        try {
            // api
            const response = await getSiteVisitReportByFolderId(folder_id);
            if (response.status) {
                return mapSiteVisitReports(response.body);
            } else {
                // If the API returns a failure status, return the error message
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            // Handle the case where the API call itself throws an error
            return rejectWithValue('Failed to fetch site visit reports');
        }
    }
);

// Fetch weather
export const fetchWeather = createAsyncThunk(
    'fetchWeather', async (_, { rejectWithValue }) => {
        try {
            // api
            const response = await getWeatherList();
            if (response.status) {
                return mapWeathers(response.body);
            } else {
                // If the API returns a failure status, return the error message
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            // Handle the case where the API call itself throws an error
            return rejectWithValue('Failed to fetch weather data');
        }
    }
);